var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"evacuation-drill-card-header",style:({
    '--width': `${_vm.width}px`,
    '--height': `${_vm.height}px`,
    '--fontSize': `${_vm.fontSize}px`,
  }),attrs:{"href":"#","aria-label":_vm.title}},[_c('object',{staticClass:"material-icons",style:({ width: `${_vm.iconSize}px`, height: `${_vm.iconSize}px` }),attrs:{"type":"image/svg+xml","data":_vm.iconSrc}}),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }